export enum CardStateEnum {
  Default = 0,
  ViewCard = 1,
  AddCard = 2,
  InProcess = 3,
}
